/**
 * 站内信 - 消息详情
 * 布局沿用了系统通用详情样式（标杆：systemNotification/detail.vue），
 * 但按常规文章阅读样式做了视觉优化：大标题居中、发送人/时间做成灰色元信息、
 * 其余字段用浅灰标签条、正文大段留白。
 * 数据来源：/api/sysConfig/Message/GetMessageDetail（MessageShowDto）
 *
 * 滚动条处理：
 * 全局工具类 .pd20 是 height:calc(100vh - 130px) + overflow:auto，
 * 当内容不足时也会保留外层滚动条槽位；本组件内再用 overflow:auto 的子容器
 * 会进一步叠加内层滚动条。站内信正文很短，必须关掉子容器的滚动，
 * 让消息直接铺在主页面（router-alive 容器）自然滚动，避免出现并排两条滚动条。
 */
<template>
	<!-- 详情 -->
	<div class="message-detail-wrap">
		<div class="pd20" style="background: #ffffff">
			<div v-if="detailData" class="detail_bg">
				<!-- 文章头部：大标题 + 元信息 -->
				<div class="article_head">
					<h1 class="article_title">{{ detailData.title }}</h1>
					<div class="article_meta">
						<span class="meta_item">发布人：{{ detailData.sendUser ? detailData.sendUser.value : "—" }}</span>
						<span class="meta_dot">·</span>
						<span class="meta_item">{{ detailData.createTime || "—" }}</span>
					</div>
				</div>

				<!-- 其余字段：浅灰标签条 -->
				<div class="meta_tags" v-if="hasExtraMeta">
					<span class="meta_tag">消息类型：{{ detailData.msgType ? detailData.msgType.dicText : "—" }}</span>
					<span class="meta_tag">所属门店：{{ detailData.belongStoreName || "—" }}</span>
					<span class="meta_tag">关联单号：{{ detailData.businessNo || "—" }}</span>
					<span class="meta_tag">状态：{{ detailData.isRead ? "已读" : "未读" }}</span>
				</div>

				<!-- 正文 -->
				<div class="content_bg">
					<div class="cb_c">{{ detailData.content }}</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { GetMessageDetail } from "../../../api/systemApi.js";
export default {
	props: {
		param: {
			type: Object,
			default: () => {}
		}
	},
	data() {
		return {
			detailData: null
		};
	},
	computed: {
		hasExtraMeta() {
			const d = this.detailData;
			if (!d) return false;
			return !!(d.msgType || d.belongStoreName || d.businessNo || d.isRead !== undefined);
		}
	},
	created() {
		this.GetMessageDetailData(this.param.row.keyId);
	},
	mounted() {},
	methods: {
		// 根据keyId获取消息详情
		GetMessageDetailData(keyId) {
			if (!keyId) {
				this.$message.error("消息参数缺失，无法查看详情！");
				return;
			}
			let params = {
				keyId: keyId
			};
			GetMessageDetail(params)
				.then((res) => {
					if (res.code === 1) {
						this.detailData = res.data;
					} else {
						this.$message.error(res.msg || "消息不存在或已删除！");
					}
				})
				.catch((err) => {
					this.$message.error("加载数据失败，请稍后再试！");
				});
		}
	}
};
</script>
<style scoped lang="scss">
/* 用 scoped 提升特异性覆盖全局 .pd20 的 height+overflow:auto，
   避免短内容时主页面的外层滚动条空跑；长内容由主页面（router-alive）自然滚动。 */
.message-detail-wrap {
	::v-deep .pd20 {
		height: auto !important;
		min-height: 0 !important;
		overflow: visible !important;
		padding-bottom: 1.5rem;
	}
}

.detail_bg {
	width: 800px;
	margin: 0 auto;
	/* 去掉自身的 overflow-y:auto，避免与外层叠加产生内层滚动条 */
}

/* 文章头部：标题居中 + 元信息小字 */
.article_head {
	text-align: center;
	padding-bottom: 18px;
	border-bottom: 1px solid var(--app-border);
}

.article_title {
	margin: 6px 0 14px;
	font-size: 24px;
	font-weight: 600;
	line-height: 1.4;
	color: var(--app-text);
	letter-spacing: 0.5px;
}

.article_meta {
	font-size: 13px;
	color: var(--app-text-muted);

	.meta_dot {
		margin: 0 8px;
	}
}

/* 其余字段：浅灰标签条 */
.meta_tags {
	display: flex;
	flex-wrap: wrap;
	margin: 18px 0 4px;
}

.meta_tag {
	margin: 0 10px 10px 0;
	padding: 5px 12px;
	font-size: 13px;
	color: var(--app-text-secondary);
	background: var(--app-surface-muted);
	border-radius: 4px;
}

/* 正文：大段留白、行高宽松 */
.content_bg {
	width: 100%;
	margin-top: 20px;
}

.cb_c {
	font-size: 15px;
	line-height: 1.9;
	color: var(--app-text-secondary);
	white-space: pre-wrap;
	word-break: break-all;
}
</style>
